export default __webpack_public_path__ + "static/media/job_offer19_s.86b149fb.jpg";